import React from "react";
import {useDispatch, useSelector} from "react-redux";
import useOnClickOutside from "use-onclickoutside";

import * as actionTypes from "../../store/actions/actionTypes";
import AdmissionDocumentPdf from "../AdmissionDocumentPdf";
import AdmissionDocumentCleanPdf from "../UI/AdmissionDocumentCleanPdf";
import PdfEmrViewToggle from "../UI/PdfEmrViewToggle";
import Admission_MhrImage from "../Lifehouse/Admission_MhrImage";
import ClinicalFlags from "./Blocks/ClinicalFlags";
import {showAdmEmrView} from "../../store/actions/modal";

const ModalLifeHouseClinicalFlags = () => {

    const dispatch = useDispatch();
    const {show, admission, admTime, selectedMessageTemplate, customUI, emrPdfToggle, cleanPdf} = useSelector(state => state.modal.clinicalFlags);
    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());

    const hideModal = () => dispatch({type: actionTypes.MODAL_CLINICAL_FLAGS_HIDE});

    // this modal is the PDF side of the switch - EMR is a separate modal, so it carries the flags over
    const showEmrView = () => dispatch(showAdmEmrView(admission, {emrPdfToggle, cleanPdf}));

    const renderMedicalHistoryPdf = () => cleanPdf
        ? <AdmissionDocumentCleanPdf documentId={admission.lifehouseFlags_hist.id}/>
        : <AdmissionDocumentPdf admissionId={admission.id} type="medicalInfo" />

    const renderCustomUIPdfContent = () => {
        if (admission.lifehouseFlags_hist || !customUI) {
            return null;
        }
        const uiData = admission.manager_customUI && admission.manager_customUI[customUI.id];
        const uploadedAt = uiData && uiData.uploadedAt;
        return (
            <div className="content-holder">
                <div className="modal-header">
                    <h5 className="modal-title h1">{customUI.managerTitle} for {admission.title} {admission.surname}, {admission.name}</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={hideModal}>
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                {uploadedAt && <div className="medical-history-signed-at-block">Uploaded at {uploadedAt}</div>}
                <AdmissionDocumentPdf admissionId={admission.id} type="customUIPDF" subType={customUI.id} />
            </div>
        );
    }

    const renderLifehouseContent = () => {
        if (!admission.lifehouseFlags_hist) {
            return null;
        }
        return (
            <div className="content-holder">
                <div className="modal-header">
                    <h5 className="modal-title h1">Medical History for {admission.firstName} {admission.lastName}</h5>
                    {emrPdfToggle && <PdfEmrViewToggle pdfView={true} onChange={pdfView => !pdfView && showEmrView()} extraClass="mr-3"/>}
                    <Admission_MhrImage admission={admission} />

                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={hideModal}>
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                {/* TODO: put values*/}
                <div className="medical-history-signed-at-block">Completed by {admission.lifehouseFlags_hist.signedByManager ? 'staff member (' + admission.lifehouseFlags_hist.signedByManager+')' : 'patient'} at {admission.lifehouseFlags_hist.completedAt}</div>
                <div className="direction-right">
                    <div className="direction-left">
                        {renderMedicalHistoryPdf()}
                    </div>
                </div>
            </div>
        );
    }

    const renderModal = () => {
        if (show) {
            return <div ref={ref} className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-body modal-cols-holder">
                        {renderLifehouseContent()}
                        {renderCustomUIPdfContent()}
                        {admission.clinicalFlags && admission.clinicalFlags.length > 0 && <ClinicalFlags admission={admission} hideModal={hideModal}/>}
                    </div>
                </div>
            </div>
        }
    }

    return (
        <div className={`modal modal-med-history fade ${show ? 'show' : ''}`} id="modalClinicalFlags" tabIndex="-1" role="dialog"
             style={{display: "block", paddingRight: "11px"}} ariaModal="true">
            {renderModal()}
        </div>
    )
}

export default ModalLifeHouseClinicalFlags;